import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'join'
})
export class JoinPipe implements PipeTransform {
    transform(input: Array<any>, sep = ',', path: string = ''): string {
        if (input) {
            if (path) {
                let stringArray: Array<any> = [];
                input.forEach((i) => {
                    stringArray.push(i[path]);
                });
                return stringArray.join(sep);
            } else {
                return input.join(sep);
            }
        } else {
            return '';
        }
    }
}
